module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAQCAYAAADJViUEAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAZdEVYdFNvZnR3YXJlAHBhaW50Lm5ldCA0LjAuMTCtCgrAAAAAmklEQVQ4T2P4jwYYkAB/0to2/qQ1TVAuGECVgQFOzSCNAslr/4MwsgFQZWCAVTOyRnQDoMrAAEMzSJFA0prfQA0gDNUM5EPEaqHKwADT5vp6JhAWTFmtDdPMm7RSHSYOVQYGWJ0NAkLJ6zThmhPWqEKF8TsbqmZU8wjUzJe8UQUqTJxmmcKVnMA0fRaYpk8x5E5khwojqf//HwD+aTl7+6/5zgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/common/Table/arrowUp.png
// module id = 850
// module chunks = 0